<div [formGroup]="formGroup" class="password-field-container">
  <input [type]="visible == false ? 'password' : 'text'" [formControlName]="fieldName" class="form-control" [ngClass]="{ 'is-invalid': submitted && form[fieldName].errors }" />
  <i class="mdi" [class]="icon" (click)="toggleVisibility()"></i>
</div>